import { MintBranchScene, type BranchStory } from '../../shared/MintBranchScene';

/** Domain concepts only: MINT-BUSINESS.md §8 confirms positioning, not features. */
export class MintBusinessScene extends MintBranchScene {
  protected readonly story: BranchStory = {
    product: 'mint-business',
    concepts: ['Organisation', 'People', 'Customers', 'Operations', 'Market', 'Performance', 'Decisions'],
    problem: ['BUSINESS GENERATES INFORMATION EVERYWHERE.', 'CONNECTED THROUGH MINT.'],
    seed: 913,
  };
}
